import { IEntity } from '@pf/shared-common';
import {
    CategoryFragment,
    ContainerFragment,
    EquipmentTypeFragment,
    ItemFragment,
    ResourceAuth,
    SlotSearchRequestParams,
    SlotType,
    SlotViewModelCreateBody,
    SlotViewModelRead,
    ZoneFragment,
} from '@control-tower/platform-wms';
import {
    ICustomFieldDto,
    ILocationFragmentDto,
} from '@pf/shared/util-platform';

export type SlotRead = SlotViewModelRead &
    IEntity & { containers: ContainerFragment[] };
export type SlotCreate = SlotViewModelCreateBody;
export type SlotSearchParams = SlotSearchRequestParams;

export class SlotDto implements IEntity {
    constructor(data: Partial<SlotDto>) {
        Object.assign(this, data);
        this.containers = data.containers || [];
    }
    id!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    slotStatus?: string | null;
    slotPriority?: number;
    reservedForLocation?: ILocationFragmentDto;
    reservedForItem?: ItemFragment;
    reservedForItemCategory?: CategoryFragment;
    zoneId!: string;
    zone!: ZoneFragment;
    slotType?: SlotType;
    minQuantityOverride?: number;
    maxQuantityOverride?: number;
    replenishFromSlotId?: string;
    barcode?: string | null;
    excludeFromOperations = false;
    containers: ContainerFragment[] = [];
    resourceAuth?: ResourceAuth;
    customFields?: ICustomFieldDto[];
    equipmentType?: EquipmentTypeFragment;
}
